/**
 * Who's searching, for the search history (server/flight-search-log.js):
 * the browser session (X-Defera-Session, the same id the cart and activity
 * log use) and, when signed in, the account's token.
 *
 * Both are read without waiting: the token comes from the latest auth event,
 * so a search never waits on a token refresh, and both modules load lazily,
 * as the rest of src/api/functions.js does, to keep them out of the search
 * page's first chunk. A search sent before they've loaded goes without them.
 */
let accessToken = null;
let sessionIdOf = null;
let started = false;

function start() {
  if (started || typeof window === 'undefined') return;
  started = true;
  import('@/lib/activityTracker')
    .then((m) => { sessionIdOf = m.getTrackingSessionId; })
    .catch(() => {});
  import('@/lib/supabase')
    .then(({ supabase }) => {
      supabase.auth.getSession()
        .then(({ data }) => { accessToken = data?.session?.access_token || null; })
        .catch(() => {});
      supabase.auth.onAuthStateChange((_event, session) => { accessToken = session?.access_token || null; });
    })
    .catch(() => {});
}
start();

/** JSON headers for a search request, with the session and account when known. */
export function searchRequestHeaders() {
  start();
  const headers = { 'Content-Type': 'application/json' };
  try {
    const id = sessionIdOf?.();
    if (id) headers['X-Defera-Session'] = String(id);
  } catch {
    /* no session id */
  }
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  return headers;
}
